import { STAGES } from './urlConstants';

export const CONTENT_TOOLBAR_OPTIONS =
  'bold italic underline |' +
  'formatselect |' +
  'bullist numlist outdent indent |' +
  'alignleft aligncenter alignright alignjustify |' +
  'backcolor forecolor fontsizeselect |' +
  'undo redo | help';

export const STYLE_TOOLBAR_OPTIONS = 'backcolor forecolor fontsizeselect | undo redo | help';

export const EDITOR_MENU = 'file edit view insert format table';

export const EDITOR_PLUGINS = [
  'paste help wordcount lists print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen link template table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount textpattern noneditable help charmap quickbars emoticons',
];

export const AUTOCOMPLETE_OPTIONS = [
  { text: 'name', value: '{{Attributes.Name}}' },
  { text: 'connection', value: '{{Attributes.MeanConnectionscore}}' },
  { text: 'level', value: '{{Attributes.Level}}' },
  { text: 'country', value: '{{Attributes.Country}}' },
];

export const QUICK_SELECTION_TOOLBAR = 'bold italic | quicklink h2 h3 blockquote quicktable';

export const CONTEXT_MENU_OPTIONS = '';

export const EDITOR_API_KEY = 'scasujyt8oqyi15xlotjww4sf4x9vzmfq7zzespb32vt91yb';
export const EDITOR_API_KEY_PROD = '0qnsvxh4pbavv6pwemcg9d3208w9ly7l7ecnwjhj8b7i47mh';

export const API_KEY = {
  [STAGES.BETA]: 'scasujyt8oqyi15xlotjww4sf4x9vzmfq7zzespb32vt91yb',
  [STAGES.PROD]: '0qnsvxh4pbavv6pwemcg9d3208w9ly7l7ecnwjhj8b7i47mh',
};

export const BACKSPACE_KEY_CODE = 8;

export const DELETE_KEY_CODE = 46;

export const HEADER = '<h1>This is a sample heading</h1>';

export const BODY_TEXT = '<p>Sample body text</p>';

export const BULLET = '<ul><li></li></ul>';

export const SECTION = {
  header: HEADER,
  bodyText: BODY_TEXT,
  bullet: BULLET,
};

export const API_ERROR = '400';

export const DEFAULT_CONTENT_STATE = {
  emailTo: '',
  emailFrom: '',
  emailSubject: '',
  errorOnSave: false,
  isLoading: false,
  isFormSaved: false,
  selectedTab: 'Content',
  expanderStates: {
    isEmailToExpanded: false,
    isEmailFromExpanded: false,
    isEmailSubjectExpanded: false,
  },
  inputValidations: {
    isEmailSubjectValid: false,
    isContentValid: false,
    isValidationTriggered: false,
    isFormValid: false,
  },
  saveAndContinueButton: {
    isOpen: false,
  },
  saveAsTemplateButton: {
    isOpen: false,
    isError: false,
    templateName: '',
    templateNameExists: false,
  },
  templatesButton: {
    isOpen: false,
    selectedTemplateName: '',
    isLoading: true,
    isErrorLoadingTemplate: false,
    selectedTemplateSubject: '',
    selectedTemplateHtml: '',
  },
};

export const EDITOR_TABS = ['Content'];
export const TAB_GROUP = 'message-content-props';
